import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function DriveOrOffice() {
  return <section className="section-padding bg-off-white" data-id="element-146">
      <div className="container-custom" data-id="element-147">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-148">
          <motion.div initial={{
          x: -20
        }} whileInView={{
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-149">
            <h2 className="text-3xl md:text-4xl font-black text-navy mb-6 tracking-tight leading-tight" data-id="element-150">
              You Can Drive the Truck or Run the Office. Doing Both Is Where
              Carriers Get Stuck.
            </h2>
            <p className="text-lg text-body font-medium leading-relaxed" data-id="element-151">
              The strongest truck in the world cannot make money sitting still.
              FSG helps take work off the driver's plate so they are not stuck
              calling brokers, chasing documents, checking portals, and handling
              paperwork after the day is done.
            </p>
          </motion.div>

          <motion.div initial={{
          x: 20
        }} whileInView={{
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-navy text-white rounded-sm p-8 md:p-10 relative overflow-hidden shadow-2xl border border-navy" data-id="element-152">
            <div className="absolute top-0 left-0 w-full h-2 bg-red" data-id="element-153" />
            <Moon className="w-9 h-9 text-amber mb-5" data-id="element-154" />
            <h3 className="text-2xl font-black text-white mb-4 font-['Barlow']" data-id="element-155">
              Stop dispatching at 8 PM.
            </h3>
            <p className="text-off-white font-medium leading-relaxed mb-8" data-id="element-156">
              You drove all day. You should not have to spend the night chasing
              brokers, paperwork, and tomorrow's freight.
            </p>
            <Link to="/contact" className="btn-primary" data-id="element-157">
              Talk to FSG About Dispatch
            </Link>
          </motion.div>
        </div>
      </div>
    </section>;
}